// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"eZ-z"};